<div class="flex flex-col items-center justify-center min-h-[60vh] gap-4 text-gray-600 px-4">
    <mat-icon class="text-8xl !w-24 !h-24 text-gray-400">lock</mat-icon>
    <h1 class="text-2xl font-semibold text-gray-800">Acceso restringido</h1>
    <p class="text-center max-w-md text-gray-500">
        No tienes los permisos necesarios para acceder a esta sección.
        Contacta al administrador de tu corporativo si necesitas acceso.
    </p>
    <button mat-raised-button color="primary" (click)="volver()">
        <mat-icon>arrow_back</mat-icon>
        Volver al inicio
    </button>
</div>